// TODO: Remove once all mappers were converted to CARMI
export const cssCarmiMappers = new Set([
	'AppWidget',
	'BackToTopButton',
	'Column',
	'ClassicSection',
	'WFacebookComment',
	'FooterContainer',
	'HeaderContainer',
	'ScreenWidthContainer',
	'LinkBar',
	'MediaBox',
	'MediaContainer',
	'MenuToggle',
	'Page',
	'PageBackground',
	'BackgroundGroup',
	'PageGroup',
	'Repeater',
	'SiteButton',
	'StripColumnsContainer',
	'tpaWidgetNative',
	'VectorImage',
	'WPhoto',
	'WRichText',
	'MenuContainer',
	'ExpandableMenu',
	'FiveGridLine',
	'TextInput',
	'ComboBoxInput',
	'ComboBoxInputListModal',
	'Container',
	'PopupContainer',
	'ItunesButton',
	'SkypeCallButton',
	'TextAreaInput',
	'Checkbox',
	'FileUploader',
	'CheckboxGroup',
	'Section',
	'RefComponent',
	'HeaderSection',
	'FooterSection',
	'MembersAreaSection',
	'RadioGroup',
	'LoginSocialBar',
	'PopupPage',
	'ResponsivePopupPage',
	'PopupCloseIconButton',
	'DropDownMenu',
	'VerticalMenu',
	'SearchBox',
	'FacebookLikeBox',
	'TinyMenu',
	'LanguageSelector',
	'QuickActionBar',
	'SignatureInput',
	'TimePicker',
	'DatePicker',
	'MediaPlayer',
	'TextMask',
	'MediaOverlayControls',
	'MediaControls',
	'AdminLoginButton',
	'Pagination',
	'SlideShowSlide',
	'PaginatedGridGallery',
	'RatingsInput',
	'RatingsDisplay',
	'SelectionTagsList',
	'RichTextBox',
	'AddressInput',
	'SelectableContainer',
])
